// src/components/sitegroup/SiteGroupForm.js
import React from 'react';
import { useForm, Controller } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';
import {
  Box,
  Button,
  TextField,
  FormControlLabel,
  Switch,
  Grid,
  CircularProgress,
  Paper,
  Typography,
  Divider
} from '@mui/material';
import CategoryIcon from '@mui/icons-material/Category';
import BusinessIcon from '@mui/icons-material/Business';

// Define validation schema
const schema = yup.object({
  SiteGroupName: yup.string().required('Site group name is required'),
  SiteGroupEnabled: yup.boolean()
}).required();

const SiteGroupForm = ({ siteGroup, companyId, onSubmit, isLoading }) => {
  const { control, handleSubmit, formState: { errors } } = useForm({
    resolver: yupResolver(schema),
    defaultValues: siteGroup ? {
      SiteGroupName: siteGroup.SiteGroupName,
      SiteGroupEnabled: siteGroup.SiteGroupEnabled
    } : {
      SiteGroupName: '',
      SiteGroupEnabled: true
    }
  });

  const onFormSubmit = (data) => {
    // Add company ID to the form data for site group creation
    const formData = {
      ...data,
      SiteCompanyId: companyId,
    };
    
    onSubmit(formData);
  };

  return (
    <Paper elevation={2} sx={{ p: 3 }}>
      <form onSubmit={handleSubmit(onFormSubmit)}>
        <Grid container spacing={3}>
          <Grid item xs={12}>
            <Typography variant="h6" gutterBottom>Site Group Information</Typography>
            <Divider sx={{ mb: 3 }} />
          </Grid>

          <Grid item xs={12}>
            <Controller
              name="SiteGroupName"
              control={control}
              render={({ field }) => (
                <TextField
                  {...field}
                  label="Site Group Name"
                  fullWidth
                  error={!!errors.SiteGroupName}
                  helperText={errors.SiteGroupName?.message}
                  required
                  InputProps={{
                    startAdornment: (
                      <CategoryIcon sx={{ mr: 1, color: 'text.secondary' }} />
                    ),
                  }}
                />
              )}
            />
          </Grid>

          <Grid item xs={12}>
            <Controller
              name="SiteGroupEnabled"
              control={control}
              render={({ field }) => (
                <FormControlLabel
                  control={
                    <Switch
                      checked={field.value}
                      onChange={(e) => field.onChange(e.target.checked)}
                    />
                  }
                  label="Site Group Enabled"
                />
              )}
            />
          </Grid>

          <Grid item xs={12}>
            <Box display="flex" justifyContent="flex-end" mt={2}>
              <Button
                type="submit"
                variant="contained"
                color="primary"
                disabled={isLoading}
                startIcon={isLoading ? <CircularProgress size={20} /> : null}
              >
                {siteGroup ? 'Update' : 'Create'} Site Group
              </Button>
            </Box>
          </Grid>
        </Grid>
      </form>
    </Paper>
  );
};

export default SiteGroupForm;